import { useCallback } from "react";
import { useRecoilState } from "recoil";
import { pricedBondState, userAuthState } from "../state";
import { toastErrorHandler } from "../unexpectedErrorHandler";
import { CorporateBondApi, listCompleteCorporateBondDetails } from "@goodfill/backend-api-client";
import { CorporateBondId, asCouponFrequency } from "@goodfill/domain-properties";
import { backendFetcher } from "./backendApi/backendApi";
import { PricedBond } from "./bonds/PricedBond";
import Decimal from "decimal.js";
import { useLogout } from "./useLogout";

export function useRefreshBondDataHook() {
  const [, setPricedBonds] = useRecoilState(pricedBondState);
  const [userAuthData] = useRecoilState(userAuthState);
  const logout = useLogout();

  return useCallback(async () => {
    if (userAuthData === null) {
      return;
    }

    (await listCompleteCorporateBondDetails(backendFetcher, userAuthData.idToken)).match({
      success: (response) =>
        setPricedBonds(
          new Map<CorporateBondId, PricedBond>(
            response.map((apiBond: CorporateBondApi) => [
              apiBond.bondIdCusip,
              {
                ...apiBond,
                couponFrequency: asCouponFrequency(new Decimal(2)),
              },
            ]),
          ),
        ),
      businessMatcher: {},
      unexpected: toastErrorHandler,
      unauthorized: logout,
    });
  }, [setPricedBonds, userAuthData, logout]);
}
